// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Palau */
const PW = /^(?:(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\d{4}|(?:45|77|88)\d{5})$/;

export default PW;
